<script>
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import DatePicker from 'vue3-persian-datetime-picker';
import $ from "jquery";
import {useRoute} from "vue-router";
import {useStore} from "vuex";


export default {
  name: "W_SignUpService",
  components: {LoadingPage, DatePicker},
  setup() {

    let store = useStore()

    let loading = ref(false)
    let dialog = ref({
      action: false,
      type: null,
    })

    let my_cars = ref([])
    let filters = ref({
      service_user: [],
    })

    let action_page = {
      type: useRoute().params.action,
      service_id: useRoute().params.service_id,
      customer_id: useRoute().params.customer_id,
    }

    let name = ref(FreeWorld.PinkMan(store.state.name_new_service , 'de'))

    let data = ref({
      action: action_page.type,
      type: "worker",
      customer_id: action_page.customer_id,
      now_km: '',
      after_km: '',
      oil_name: "",
      details: "",
      description: "",
      service_date: null,
      oil_reminder: null,
      gris_reminder: null,
      havakesh: [],
      gris: [],
      bolbring: [],
      lent: [],
      radiator: [],
      oil: [],
      filter: []
    })

    let filters_checkbox = ref({
      havakesh: false,
      gris: false,
      bolbring: false,
      lent: false,
      radiator: false,
    })


    function get_filters() {
      loading.value = true
        FreeWorld.Heisenberg({action: 'service'}, 'public_info').then((res) => {
          loading.value = false
          filters.value = res.data

          if (action_page.type !== 'add_worker') details_service()
        }).catch((res) => {
          loading.value = false
          Swals.Catch(res, get_filters)
        })
    }
    get_filters()

    function details_service() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'show_detail', service_id: action_page.service_id}, 'worker/my_service', true).then((res) => {
        loading.value = false
        let data_name = ['now_km','after_km','oil_name','details','description','oil_reminder','gris_reminder','havakesh', 'gris','bolbring','lent','radiator','oil','filter']

        data_name.forEach((item)=>{
          data.value[item] = res.data[item]
        })

        data.value.service_date = res.data.service_date_persian

        check_filters_checkbox()
        select_service_name()
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, details_service)
      })
    }

    let select_filter_items = ref(null)
    let type_chang_items
    let content = ref('')
    let price = ref('')

    function chang_items(action, type) {
      if (data.value.action === 'show_detail') return false

      let div_dialog = $("#dialog")

      switch (action) {
        case 'show':
          if (dialog.value.action) {
            div_dialog.removeClass('animate__fadeIn').addClass('animate__fadeOut')
            setTimeout(() => {
              check_filters_checkbox()
              dialog.value.action = false
              select_filter_items.value = null
              content.value = ''
              price.value = ''
            }, 700)
          } else {
            div_dialog.removeClass('animate__fadeOut').addClass('animate__fadeIn')
            dialog.value.type = type
            dialog.value.action = true
            type_chang_items = type
          }
          break;

        case 'accept':
          if (type_chang_items === 'oil' || type_chang_items === 'filter') {
            if (select_filter_items.value === null || price.value.length === 0) {
              Swals.Warning('لطفا مقادیر درخواستی را تکمیل کنید!');
              return false
            }
            filters.value[type_chang_items].forEach((item) => {
              if (item.id === select_filter_items.value) {
                content.value = item.name
                return false
              }
            })
            data.value[type_chang_items].push({
              id: select_filter_items.value,
              content: content.value,
              price: price.value
            })
            chang_items('show')
          } else {

            if (content.value.trim().length === 0 || price.value.length === 0) {
              Swals.Warning('لطفا مقادیر درخواستی را تکمیل کنید!');
              return false
            }

            if (data.value[type_chang_items].length > 0){
              data.value[type_chang_items] = []
            }

            data.value[type_chang_items].push({content: content.value, price: price.value})
            chang_items('show')
          }
      }
    }

    let input_select_name = ref(false)

    function select_service_name() {
      if (data.value.service_users_id === '') {
        input_select_name.value = true
        document.addEventListener('DOMContentLoaded', () => {
          const carInput = document.getElementById('input_select_service_name');
          carInput.focus();
        });
      }
    }

    function check_filters_checkbox() {
      let filter_items = ['havakesh', 'gris', 'bolbring', 'lent', 'radiator']
      filter_items.forEach((item) => {
        if (data.value[item].length < 1) {
          filters_checkbox.value[item] = false
        }else {
          filters_checkbox.value[item] = true
        }
      })
    }

    function register_service() {
      // if (data.value.servicer_name.length > 0) data.value.service_users_id = null
      // if (data.value.cars_id === null) {
      //   Swals.Warning('لطفا خودروی مورد نظر خود را انتخاب کنید!');
      //   return false
      // }

      // if (data.value.service_users_id === null && data.value.servicer_name.trim().length === 0) {
      //   Swals.Warning('لطفا سرویس دهنده ی خود را انتخاب کنید!');
      //   return false
      // }

      if (data.value.service_date === null) {
        Swals.Warning('لطفا تاریخ سرویس را وارد کنید!');
        return false
      }
      if (data.value.now_km.length === 0 || data.value.after_km.length === 0) {
        Swals.Warning('لطفا کیلومتر فعلی و کیلومتر بعدی را وارد کنید!');
        return false
      }

      if (action_page.type === 'edit_worker') data.value.service_id = action_page.service_id

      loading.value = true
      FreeWorld.Heisenberg(data.value, 'manage_car_service', true).then((res) => {
        loading.value = false
        if (res.data.status === 'ok') {
          Swals.Done('سرویس شما با موفقیت ثبت شد' , 'back')

        } else {
          Swals.Fault('متاسفانه سرویس شما ثبت نشد!')
        }
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, register_service)
      })
    }

    return {
      loading,
      my_cars,
      input_select_name,
      select_service_name,
      data,
      filters,
      filters_checkbox,
      dialog,
      chang_items,
      select_filter_items,
      price,
      content,
      register_service,
      name,
    }
  }
}
</script>

<template>

  <LoadingPage v-show="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">

    <div v-if="dialog.action" @click="chang_items('show')" class="bg_dialog"></div>

    <div v-if="dialog.action" id="dialog" class="dialog animate__animated animate__fadeIn px-3">
      <div class="rounded-4 bg-white p-3">
        <div class="position-relative">
          <p class="font-4 text-color font-bold text-center">نوع و قیمت را مشخص کنید</p>
          <img @click="chang_items('show')" class="icon-size-3 position-absolute top-0 start-0"
               src="../assets/img/icon-closeBgColor.svg" alt="">
        </div>

        <hr>

        <div v-if="dialog.type === 'oil'" class="d-flex justify-content-center">
          <select v-model="select_filter_items" class="p-3 w-70 bg-custom rounded-pill shadow-custom mb-4 text-center">
            <option :value="null" hidden>انتخاب نوع روغن</option>
            <option v-for="item in filters.oil" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
        </div>

        <div v-else-if="dialog.type === 'filter'" class="d-flex justify-content-center">
          <select v-model="select_filter_items" class="p-3 w-70 bg-custom rounded-pill shadow-custom mb-4 text-center">
            <option :value="null" hidden>انتخاب نوع فیلتر</option>
            <option v-for="item in filters.filter" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
        </div>

        <div v-else class="d-flex justify-content-center">
          <input v-model="content" class="p-3 w-70 bg-custom rounded-pill shadow-custom mb-5 text-center" type="text"
                 placeholder="نام یا شماره">
        </div>

        <div class="d-flex justify-content-center">
          <input v-model="price" class="p-3 w-70 bg-custom rounded-pill shadow-custom mb-5 text-center"
                 onkeydown="return event.key !== ' '" type="tel" placeholder="قیمت (تومان)">
        </div>

        <div class="d-flex justify-content-center">
          <p @click="chang_items('accept')"
             class="font-4 font-bold text-center rounded-pill bg-color-liner text-white p-3 w-35">ثبت</p>
        </div>
      </div>
    </div>

    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      <p v-show="data.action === 'add_worker'" class="text-white font-bold font-4">ثبت سرویس</p>
      <p v-show="data.action === 'show_detail'" class="text-white font-bold font-4">جزئیات سرویس</p>
      <p v-show="data.action === 'edit_worker'" class="text-white font-bold font-4">ویرایش سرویس</p>
    </div>

<!--    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">-->
<!--      <div class="d-flex justify-content-between p-3 bg-custom rounded-pill shadow mb-4">-->
<!--        <p class="font-4 text-color">نام خودرو :</p>-->

<!--        <select v-model="data.cars_id" :disabled="data.action !== 'add_worker'" class="border-0 bg-custom w-70 text-center font-4">-->
<!--          <option v-for="item in my_cars" :key="item.id" :value="item.id" class="font-5">{{ item.name }}</option>-->
<!--        </select>-->
<!--      </div>-->

<!--      <div class="d-flex justify-content-between align-items-center p-3 bg-custom rounded-pill shadow mb-4">-->
<!--        <p class="font-4 text-color">انتخاب سرویس دهنده :</p>-->

<!--        <div class="bg-custom w-50">-->
<!--          <input v-if="input_select_name" v-model="data.servicer_name" type="text" id="input_select_service_name"-->
<!--                 :disabled="data.action !== 'add_worker'"  class="w-100 font-5 bg-custom" autofocus>-->
<!--          <select v-else v-model="data.service_users_id" @change="select_service_name" :disabled="data.action !== 'add_worker'"-->
<!--                  class="w-100 bg-custom border-0 font-5 text-center">-->
<!--            <option class="font-5 text-center" value="">وارد کردن نام</option>-->
<!--            <option v-for="item in filters.service_user" :key="item.id" class="font-5" :value="item.id">-->
<!--              {{ item.name }}-->
<!--            </option>-->
<!--          </select>-->
<!--        </div>-->

<!--      </div>-->


        <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
          <div class="d-flex justify-content-between p-3 bg-custom rounded-pill shadow mb-4">
            <p class="font-4 text-color">نام مشتری :</p>

          <p class="bg-custom w-75 text-center font-4">{{ name }}</p>
          </div>

      <div class="d-flex justify-content-between p-3 bg-custom rounded-pill shadow mb-4">
        <p class="font-4 text-color">تاریخ سرویس :</p>

        <DatePicker :disabled="data.action === 'show_detail'" dir="ltr" v-model="data.service_date"></DatePicker>
      </div>

      <div class="d-flex justify-content-between">
        <div class="d-flex justify-content-between p-3 bg-custom shadow rounded-pill w-45">
          <p class="font-6 text-color">کیلومتر فعلی :</p>

          <input v-model="data.now_km" onkeydown="return event.key !== ' '" :disabled="data.action === 'show_detail'"
                 class="border-0 bg-custom w-50 text-start font-6" type="tel">
        </div>

        <div class="d-flex justify-content-between p-3 bg-custom shadow rounded-pill w-45">
          <p class="font-6 text-color">کیلومتر بعدی :</p>

          <input v-model="data.after_km" onkeydown="return event.key !== ' '" :disabled="data.action === 'show_detail'"
                 class="border-0 bg-custom w-50 text-start font-6" type="tel">
        </div>
      </div>

      <div class="hr-div my-4"></div>

      <div @click="chang_items('show' , 'oil')"
           class="d-flex justify-content-between p-3 bg-custom shadow rounded-pill">
        <p class="font-4 text-color">تعویض روغن :</p>

        <img class="icon-size-3" src="../assets/img/icon-plusBgColor.svg" alt="">
      </div>

      <div class="">
        <div v-for="(item , index) in data.oil" :key="index" class="d-flex align-items-center justify-content-between mt-3">
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-50">{{ item.content }}</p>
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-45">قیمت : {{parseInt(item.price).toLocaleString() }}</p>
        </div>
      </div>

      <div class="d-flex justify-content-between p-3 bg-custom rounded-pill shadow my-4">
        <p class="font-4 text-color">نام روغن :</p>

        <input v-model="data.oil_name" :disabled="data.action === 'show_detail'" class="w-75 border-0 bg-custom" type="text">
      </div>

      <div @click="chang_items('show' , 'filter')"
           class="d-flex justify-content-between p-3 bg-custom shadow rounded-pill">
        <p class="font-4 text-color">فیلتر های تعویض شده :</p>

        <img class="icon-size-3" src="../assets/img/icon-plusBgColor.svg" alt="">
      </div>

      <div class="">
        <div v-for="(item , index) in data.filter" :key="index"
             class="d-flex align-items-center justify-content-between mt-3">
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-50">{{ item.content }}</p>
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-45">قیمت : {{
              parseInt(item.price).toLocaleString()
            }}</p>
        </div>
      </div>

      <div class="d-flex p-3 bg-custom rounded-pill shadow mt-4">
        <input v-model="filters_checkbox.havakesh" @change="chang_items('show' , 'havakesh')" id="filter"
               :disabled="data.action === 'show_detail'"  class="font-4 text-color ms-2" type="checkbox">
        <label class="w-85 font-4 text-color" for="filter">بادگیری هواکش</label>
      </div>

      <div class="">
        <div v-for="(item , index) in data.havakesh" :key="index"
             class="d-flex align-items-center justify-content-between mt-3">
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-50">نام : {{ item.content }}</p>
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-45">قیمت : {{
              parseInt(item.price).toLocaleString()
            }}</p>
        </div>
      </div>

      <div class="d-flex justify-content-between p-3 bg-custom shadow rounded-pill mt-4">
        <p class="font-4 text-color">زمان ارسال یادآور :</p>

        <DatePicker :disabled="data.action === 'show_detail'" dir="ltr" v-model="data.oil_reminder" class="w-60"></DatePicker>
      </div>

      <div class="hr-div my-4"></div>

      <div class="d-flex p-3 bg-custom rounded-pill shadow mt-4">
        <input v-model="filters_checkbox.gris" @change="chang_items('show' , 'gris')" id="grise"
               :disabled="data.action === 'show_detail'"  class="font-4 text-color ms-2" type="checkbox">
        <label class="w-85 font-4 text-color" for="grise">تعویض گریس :</label>
      </div>

      <div class="">
        <div v-for="(item , index) in data.gris" :key="index"
             class="d-flex align-items-center justify-content-between mt-3">
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-50">نام گریس : {{ item.content }}</p>
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-45">قیمت : {{
              parseInt(item.price).toLocaleString()
            }}</p>
        </div>
      </div>

      <div class="d-flex p-3 bg-custom rounded-pill shadow mt-4">
        <input v-model="filters_checkbox.bolbring" @change="chang_items('show' , 'bolbring')" id="ballbearings"
               :disabled="data.action === 'show_detail'" class="font-4 text-color ms-2" type="checkbox">
        <label class="w-85 font-4 text-color" for="ballbearings">تعویض بلبرینگ :</label>
      </div>

      <div class="">
        <div v-for="(item , index) in data.bolbring" :key="index"
             class="d-flex align-items-center justify-content-between mt-3">
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-50">نام بلبرینگ : {{ item.content }}</p>
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-45">قیمت : {{
              parseInt(item.price).toLocaleString()
            }}</p>
        </div>
      </div>

      <div class="d-flex p-3 bg-custom rounded-pill shadow mt-4">
        <input v-model="filters_checkbox.lent" @change="chang_items('show' , 'lent')" id="lent"
               :disabled="data.action === 'show_detail'" class="font-4 text-color ms-2" type="checkbox">
        <label class="w-85 font-4 text-color" for="lent">تعویض لنت :</label>
      </div>

      <div class="">
        <div v-for="(item , index) in data.lent" :key="index"
             class="d-flex align-items-center justify-content-between mt-3">
          <p class="font-5 drop_shadow p-3 rounded-pill bg-custom w-50">نام لنت : {{ item.content }}</p>
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-45">قیمت : {{
              parseInt(item.price).toLocaleString()
            }}</p>
        </div>
      </div>

      <div class="d-flex p-3 bg-custom rounded-pill shadow mt-4">
        <input v-model="filters_checkbox.radiator" @change="chang_items('show' , 'radiator')" id="Antifreeze"
               :disabled="data.action === 'show_detail'"  class="font-4 text-color ms-2" type="checkbox">
        <label class="w-85 font-4 text-color" for="Antifreeze">آب رادیاتور و ضد یخ :</label>
      </div>

      <div class="">
        <div v-for="(item , index) in data.radiator" :key="index"
             class="d-flex align-items-center justify-content-between mt-3">
          <p class="font-5 drop_shadow p-3 rounded-pill bg-custom w-50">نام : {{ item.content }}</p>
          <p class="font-5 p-3 rounded-pill bg-custom drop_shadow w-45">قیمت : {{
              parseInt(item.price).toLocaleString()
            }}</p>
        </div>
      </div>

      <div class="d-flex justify-content-between p-3 bg-custom shadow rounded-pill mt-4">
        <p class="font-4 text-color">زمان ارسال یادآور :</p>

        <DatePicker :disabled="data.action === 'show_detail'" dir="ltr" v-model="data.gris_reminder" class="w-60"></DatePicker>
      </div>

      <div class="hr-div my-4"></div>

      <div class="p-3 bg-custom shadow rounded-4 mb-4">
        <p class="font-4 text-color mb-2">وسایل خرده کاری :</p>
        <textarea :disabled="data.action === 'show_detail'" v-model="data.details" class="w-100 rounded-4 p-3 font-4" rows="3"></textarea>
      </div>

      <div class="p-3 bg-custom shadow rounded-4 mb-5">
        <p class="font-4 text-color mb-2">توضیحات دیگر :</p>
        <textarea :disabled="data.action === 'show_detail'" v-model="data.description" class="w-100 rounded-4 p-3 font-4" rows="3"></textarea>
      </div>

      <div v-show="data.action === 'add_worker'" class="d-flex justify-content-center">
        <p @click="register_service" class="bg-color-liner w-35 text-white rounded-pill p-3 text-center font-bold font-4">ثبت</p>
      </div>
    </div>
  </div>

</template>

<style scoped>
.hr-div {
  width: 100%;
  height: .1rem;
  border-bottom: .1rem dashed #0335BE;
}
</style>